var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9040215ClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9040215_clock_icon",
    "data-name": "9040215_clock_icon",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34441",
    "data-name": "Path 34441",
    d: "M9.473,4.237A1.237,1.237,0,0,0,7,4.237v13.6a1.237,1.237,0,0,0,.623,1.073l8.657,4.947a1.237,1.237,0,0,0,1.227-2.147L9.473,17.123Z",
    transform: "translate(10.573 4.59)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34442",
    "data-name": "Path 34442",
    d: "M20,40A20,20,0,1,0,0,20,20,20,0,0,0,20,40ZM37.5,20A17.5,17.5,0,1,1,20,2.5,17.5,17.5,0,0,1,37.5,20Z",
    stroke: "#000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9040215ClockIcon);
export default __webpack_public_path__ + "static/media/9040215_clock_icon.3f306289553b2dea43b8bbbb65e83687.svg";
export { ForwardRef as ReactComponent };